// Cliente HTTP del modulo Cumplimiento Clientes.
// Reusa fetchApi (auth + refresh) para mantener el mismo contrato que
// el resto del frontend.

import { fetchApi } from '../api';
import type {
  CustomerFulfillmentKpisResponse,
  CustomerFulfillmentListParams,
  CustomerFulfillmentOrderDetailResponse,
  CustomerFulfillmentOrdersResponse,
  TopCustomersResponse,
} from './customerFulfillment.types';

const BASE_PATH = 'customer-fulfillment';

class CustomerFulfillmentService {
  async getKpis(warehouseId?: number): Promise<CustomerFulfillmentKpisResponse> {
    const params = typeof warehouseId === 'number' ? { warehouse_id: warehouseId } : undefined;
    return fetchApi<CustomerFulfillmentKpisResponse>(`${BASE_PATH}/kpis/`, { params });
  }

  async getTopCustomers(limit = 10, warehouseId?: number): Promise<TopCustomersResponse> {
    const params: Record<string, string | number | boolean> = { limit };
    if (typeof warehouseId === 'number') params.warehouse_id = warehouseId;
    return fetchApi<TopCustomersResponse>(`${BASE_PATH}/top-customers/`, {
      params,
    });
  }

  async listOrders(
    params?: CustomerFulfillmentListParams
  ): Promise<CustomerFulfillmentOrdersResponse> {
    const queryParams: Record<string, string | number | boolean> = {};
    if (params?.page) queryParams.page = params.page;
    if (params?.page_size) queryParams.page_size = params.page_size;
    if (params?.search) queryParams.search = params.search;
    if (params?.only_at_risk !== undefined) queryParams.only_at_risk = params.only_at_risk;
    if (params?.risk_filter) queryParams.risk_filter = params.risk_filter;
    if (params?.include_overdue !== undefined) queryParams.include_overdue = params.include_overdue;
    if (typeof params?.warehouse_id === 'number') queryParams.warehouse_id = params.warehouse_id;
    return fetchApi<CustomerFulfillmentOrdersResponse>(`${BASE_PATH}/orders/`, {
      params: queryParams,
    });
  }

  async getOrderDetail(
    salesOrderId: number,
    warehouseId?: number
  ): Promise<CustomerFulfillmentOrderDetailResponse> {
    const params = typeof warehouseId === 'number' ? { warehouse_id: warehouseId } : undefined;
    return fetchApi<CustomerFulfillmentOrderDetailResponse>(
      `${BASE_PATH}/orders/${salesOrderId}/`,
      { params }
    );
  }
}

export const customerFulfillmentService = new CustomerFulfillmentService();
